import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4 text-center" }
const _hoisted_2 = { class: "px-4 py-8 mb-12 bg-white border shadow-lg sm:rounded-lg sm:px-10" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "flex justify-center mt-2 min-w-100" }
const _hoisted_5 = {
  class: "min-w-full",
  "aria-label": "Who is this account for?"
}
const _hoisted_6 = {
  class: "grid grid-cols-2 p-1 font-semibold text-center rounded-full gap-x-1 text-xs/5 ring-1 ring-gray-200 ring-inset",
  id: "headlessui-radiogroup-:r0:",
  role: "radiogroup"
}
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_9 = {
  id: "form-signup",
  role: "form",
  class: "mt-6 space-y-6"
}
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = {
  key: 1,
  class: "sm:mt-8"
}
const _hoisted_16 = { class: "my-4 space-y-3 text-sm" }
const _hoisted_17 = { class: "pb-4 border-b border-gray-900/10" }
const _hoisted_18 = { class: "mt-10 space-y-10" }
const _hoisted_19 = { class: "mt-6 space-y-3" }
const _hoisted_20 = { class: "flex gap-3" }
const _hoisted_21 = { class: "flex items-center h-6 shrink-0" }
const _hoisted_22 = { class: "grid grid-cols-1 group size-4" }
const _hoisted_23 = { class: "flex gap-3" }
const _hoisted_24 = { class: "flex items-center h-6 shrink-0" }
const _hoisted_25 = { class: "grid grid-cols-1 group size-4" }
const _hoisted_26 = { class: "flex gap-3" }
const _hoisted_27 = { class: "flex items-center h-6 shrink-0" }
const _hoisted_28 = { class: "grid grid-cols-1 group size-4" }
const _hoisted_29 = { class: "flex gap-3" }
const _hoisted_30 = { class: "flex items-center h-6 shrink-0" }
const _hoisted_31 = { class: "grid grid-cols-1 group size-4" }
const _hoisted_32 = { class: "pb-4 border-b border-gray-900/10" }
const _hoisted_33 = { class: "grid grid-cols-1 mt-4 gap-x-6 gap-y-4 sm:grid-cols-6" }
const _hoisted_34 = { class: "sm:col-span-6" }
const _hoisted_35 = { class: "mt-2" }
const _hoisted_36 = { class: "pb-4 border-b border-gray-900/10" }
const _hoisted_37 = { class: "grid grid-cols-1 mt-4 gap-x-6 gap-y-4 sm:grid-cols-6" }
const _hoisted_38 = { class: "sm:col-span-6" }
const _hoisted_39 = { class: "mt-2" }
const _hoisted_40 = { class: "sm:col-span-6" }
const _hoisted_41 = { class: "mt-1" }
const _hoisted_42 = ["type"]
const _hoisted_43 = { class: "sm:col-span-6" }
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = { class: "flex items-center justify-between" }
const _hoisted_46 = { class: "flex items-center" }

import {computed, Ref, ref} from "vue";
import {client} from '@/shared';
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {CreateAccount, CreateAccountResponse, Region} from "@/dtos";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateAccount',
  props: {
    id: {
        type: String,
        default: ''
    },
    email: {
        type: String,
        default: ''
    },
    fromEu: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

// @ts-ignore
const props = __props;

const agreeToAgeVerify = ref(false);
const agreeToCollectConsent = ref(false);
const agreeToCompliance = ref(false);
const agreeToRevokeConsent = ref(false);


const attemptedToSubmit = ref(false);
const isSubmitting = ref(false);
const request = ref(new CreateAccount({
    id: props.id,
    name: '',
    password: '',
    agreeToNewsletters: !props.fromEu,
    accountIsForChild: false,
    childDisplayName: '',
    agreeToAllChildAccountConsents: false
}));

const agreeToAllChildAccountConsents = computed(() =>
    agreeToAgeVerify.value &&
    agreeToCollectConsent.value &&
    agreeToCompliance.value &&
    agreeToRevokeConsent.value
);

const createSuccessful: Ref<Boolean> = ref(false);
const responseStatus = ref({});

const createAccount = async () => {
    attemptedToSubmit.value = true;

    isSubmitting.value = true;
    request.value.agreeToAllChildAccountConsents = agreeToAllChildAccountConsents;

    await client.post<CreateAccountResponse>(request.value)
        .then((response) => {
            createSuccessful.value = true;
            responseStatus.value = {};
            location.href = response.redirectToUrl;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    isSubmitting.value = false;
}

const passwordVisible = ref(false);
const togglePasswordVisibility = () => {
    passwordVisible.value = !passwordVisible.value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("em", null, "Thank you for confirming " + _toDisplayString(props.email) + ".", 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "mb-2 text-xl font-semibold text-center text-gray-900" }, "Welcome to StageAgent!", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "mb-2 text-sm text-center" }, "Please complete the steps below to finish creating your account", -1)),
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mt-6 mb-2 font-semibold text-center text-clay-900" }, "Who is this account for?", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("fieldset", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (request.value.accountIsForChild = false), ["prevent"])),
                class: _normalizeClass(["cursor-pointer rounded-full px-2.5 py-1 text-clay-800", !request.value.accountIsForChild ? 'bg-electric-600 text-white' : '']),
                id: "headlessui-radio-:r1:",
                role: "radio",
                "aria-checked": "true",
                tabindex: "0"
              }, "Myself", 2),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (request.value.accountIsForChild = true), ["prevent"])),
                class: _normalizeClass(["cursor-pointer rounded-full px-2.5 py-1 text-clay-800", request.value.accountIsForChild ? 'bg-electric-600 text-white' : '']),
                id: "headlessui-radio-:r2:",
                role: "radio",
                "aria-checked": "false",
                tabindex: "-1"
              }, "My Child", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"])
        ])
      ]),
      (!request.value.accountIsForChild)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                  for: "name",
                  class: "block text-sm font-medium text-gray-700"
                }, "Your Name", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((request.value.name) = $event)),
                    id: "name",
                    name: "name",
                    placeholder: "Your first and last name",
                    type: "text",
                    autocomplete: "name",
                    required: "",
                    autofocus: "",
                    class: "block w-full px-3 py-2 placeholder-gray-400 border rounded-md shadow-sm appearance-none border-clay-500 focus:outline-hidden focus:ring-slate-500 focus:border-slate-500 sm:text-sm"
                  }, null, 512), [
                    [_vModelText, request.value.name]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  for: "password",
                  class: "block text-sm font-medium text-gray-700"
                }, " Password ", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((request.value.password) = $event)),
                    id: "password",
                    name: "password",
                    type: passwordVisible.value ? 'text' : 'password',
                    autocomplete: "off",
                    placeholder: "Choose a password",
                    required: "",
                    class: "block w-full px-3 py-2 placeholder-gray-400 border rounded-md shadow-sm appearance-none border-clay-500 focus:outline-hidden focus:ring-slate-500 focus:border-slate-500 sm:text-sm"
                  }, null, 8, _hoisted_12), [
                    [_vModelDynamic, request.value.password]
                  ])
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mt-2 text-sm text-clay-800" }, "Your password must be at least 6 characters long and must contain at least one uppercase, one lowercase, and one numerical character.", -1))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((request.value.agreeToNewsletters) = $event)),
                    id: "agreeToNewsletters",
                    name: "agreeToNewsletters",
                    type: "checkbox",
                    value: "true",
                    class: "w-4 h-4 rounded border-clay-500 text-slate-800 focus:ring-slate-500"
                  }, null, 512), [
                    [_vModelCheckbox, request.value.agreeToNewsletters]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "agreeToNewsletters",
                    class: "block ml-2 text-sm text-gray-900"
                  }, " Get emails about theatre news, tips, auditions, and offers. Customize preferences anytime in Account Settings. ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(SaButton, {
                  onClick: _withModifiers(createAccount, ["prevent"]),
                  loading: isSubmitting.value,
                  variant: "primary"
                }, {
                  loading: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" Submitting... ")
                  ])),
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createTextVNode(" Create My Account "))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[41] || (_cache[41] = _createElementVNode("p", null, "Thank you for your interest in creating a StageAgent account on behalf of your child. StageAgent is committed to protecting your child’s privacy and providing a safe, educational, and engaging environment. ", -1)),
              _cache[42] || (_cache[42] = _createElementVNode("p", null, "We collect and process your child’s information to provide access to StageAgent services, including personalized profiles, theatre resources, and educational content. ", -1)),
              _cache[43] || (_cache[43] = _createElementVNode("p", null, "Parents and legal guardians are responsible for creating and maintaining your child’s profile, visibility settings, reviewing any notifications, messages, invitations or job opportunities. ", -1)),
              _cache[44] || (_cache[44] = _createElementVNode("p", null, "Parents and legal guardians must use their own name and email address to create an account. However, you can choose to display your child’s name, images, videos, CV, appearance, credits, and/or skills on your public profile.", -1)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("fieldset", null, [
                    _cache[30] || (_cache[30] = _createElementVNode("legend", { class: "font-semibold text-gray-900 text-sm/6" }, " Please review and acknowledge the following: ", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agreeToAgeVerify).value = $event)),
                              id: "age-verify",
                              "aria-describedby": "age-verify",
                              name: "age-verify",
                              type: "checkbox",
                              class: "col-start-1 row-start-1 bg-white border rounded-sm appearance-none border-clay-500 checked:border-electric-600 checked:bg-electric-600 indeterminate:border-electric-600 indeterminate:bg-electric-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600 disabled:border-clay-500 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            }, null, 512), [
                              [_vModelCheckbox, agreeToAgeVerify.value]
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("svg", {
                              class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                              viewBox: "0 0 14 14",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-checked:opacity-100",
                                d: "M3 8L6 11L11 3.5",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-indeterminate:opacity-100",
                                d: "M3 7H11",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1))
                          ])
                        ]),
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-sm/6" }, [
                          _createElementVNode("label", {
                            for: "age-verify",
                            class: "font-medium text-gray-900"
                          }, "I am the parent or legal guardian of the child using this account and I confirm that I am at least 18 years old. ")
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agreeToCollectConsent).value = $event)),
                              id: "consent-collect",
                              "aria-describedby": "consent-collect",
                              name: "consent-collect",
                              type: "checkbox",
                              class: "col-start-1 row-start-1 bg-white border rounded-sm appearance-none border-clay-500 checked:border-electric-600 checked:bg-electric-600 indeterminate:border-electric-600 indeterminate:bg-electric-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600 disabled:border-clay-500 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            }, null, 512), [
                              [_vModelCheckbox, agreeToCollectConsent.value]
                            ]),
                            _cache[24] || (_cache[24] = _createElementVNode("svg", {
                              class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                              viewBox: "0 0 14 14",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-checked:opacity-100",
                                d: "M3 8L6 11L11 3.5",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-indeterminate:opacity-100",
                                d: "M3 7H11",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1))
                          ])
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-sm/6" }, [
                          _createElementVNode("label", {
                            for: "consent-collect",
                            class: "font-medium text-gray-900"
                          }, [
                            _createTextVNode("I consent to the collection, use, and storage of my child’s personal information as outlined in the "),
                            _createElementVNode("a", {
                              href: "/pages/privacy",
                              target: "_blank",
                              class: "underline"
                            }, "StageAgent Privacy Policy"),
                            _createTextVNode(". ")
                          ])
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agreeToCompliance).value = $event)),
                              id: "compliance",
                              "aria-describedby": "compliance",
                              name: "compliance",
                              type: "checkbox",
                              class: "col-start-1 row-start-1 bg-white border rounded-sm appearance-none border-clay-500 checked:border-electric-600 checked:bg-electric-600 indeterminate:border-electric-600 indeterminate:bg-electric-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600 disabled:border-clay-500 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            }, null, 512), [
                              [_vModelCheckbox, agreeToCompliance.value]
                            ]),
                            _cache[26] || (_cache[26] = _createElementVNode("svg", {
                              class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                              viewBox: "0 0 14 14",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-checked:opacity-100",
                                d: "M3 8L6 11L11 3.5",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-indeterminate:opacity-100",
                                d: "M3 7H11",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1))
                          ])
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-sm/6" }, [
                          _createElementVNode("label", {
                            for: "compliance",
                            class: "font-medium text-gray-900"
                          }, [
                            _createTextVNode("I agree to manage my child’s account and ensure compliance with "),
                            _createElementVNode("a", {
                              href: "/pages/terms",
                              target: "_blank",
                              class: "underline"
                            }, "StageAgent’s Terms of Service"),
                            _createTextVNode(". ")
                          ])
                        ], -1))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((agreeToRevokeConsent).value = $event)),
                              id: "offers",
                              "aria-describedby": "offers-description",
                              name: "offers",
                              type: "checkbox",
                              class: "col-start-1 row-start-1 bg-white border rounded-sm appearance-none border-clay-500 checked:border-electric-600 checked:bg-electric-600 indeterminate:border-electric-600 indeterminate:bg-electric-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600 disabled:border-clay-500 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                            }, null, 512), [
                              [_vModelCheckbox, agreeToRevokeConsent.value]
                            ]),
                            _cache[28] || (_cache[28] = _createElementVNode("svg", {
                              class: "pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25",
                              viewBox: "0 0 14 14",
                              fill: "none"
                            }, [
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-checked:opacity-100",
                                d: "M3 8L6 11L11 3.5",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-0 group-has-indeterminate:opacity-100",
                                d: "M3 7H11",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1))
                          ])
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-sm/6" }, [
                          _createElementVNode("label", {
                            for: "offers",
                            class: "font-medium text-gray-900"
                          }, "I understand that I can revoke consent at any time by deleting my account in my Account Settings or by contacting StageAgent customer support at support@stageagent.com. ")
                        ], -1))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[32] || (_cache[32] = _createElementVNode("h2", { class: "font-semibold text-gray-900 text-base/7" }, "Digital signature", -1)),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                      for: "first-name",
                      class: "block font-medium text-gray-900 text-sm/6"
                    }, "Your Name", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((request.value.name) = $event)),
                        type: "text",
                        name: "first-name",
                        id: "first-name",
                        autocomplete: "given-name",
                        class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-electric-600 sm:text-sm/6",
                        placeholder: "Parent/Guardian Full Legal Name"
                      }, null, 512), [
                        [_vModelText, request.value.name]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _cache[37] || (_cache[37] = _createElementVNode("h2", { class: "font-semibold text-gray-900 text-base/7" }, "Account", -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                      for: "email-address",
                      class: "block font-medium text-gray-900 text-sm/6"
                    }, "Your Email", -1)),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("p", null, _toDisplayString(props.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", {
                      for: "password",
                      class: "block text-sm font-medium text-gray-700"
                    }, " Choose a Password. ", -1)),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((request.value.password) = $event)),
                        id: "password",
                        name: "password",
                        type: passwordVisible.value ? 'text' : 'password',
                        autocomplete: "off",
                        placeholder: "Choose a password",
                        required: "",
                        class: "block w-full px-3 py-2 placeholder-gray-400 border rounded-md shadow-sm appearance-none border-clay-500 focus:outline-hidden focus:ring-slate-500 focus:border-slate-500 sm:text-sm"
                      }, null, 8, _hoisted_42), [
                        [_vModelDynamic, request.value.password]
                      ])
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("p", { class: "mt-2 text-sm text-clay-800" }, "Your password must be at least 6 characters long and must contain at least one uppercase, one lowercase, and one numerical character.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", {
                      for: "child-name",
                      class: "block font-medium text-gray-900 text-sm/6"
                    }, " Child's Name (Profile Display Name)", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((request.value.childDisplayName) = $event)),
                        id: "child-name",
                        name: "child-name",
                        type: "email",
                        autocomplete: "child-name",
                        class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-electric-600 sm:text-sm/6",
                        placeholder: "Child's name"
                      }, null, 512), [
                        [_vModelText, request.value.childDisplayName]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((request.value.agreeToNewsletters) = $event)),
                    id: "agreeToNewsletters",
                    name: "agreeToNewsletters",
                    type: "checkbox",
                    class: "w-4 h-4 rounded border-clay-500 text-slate-800 focus:ring-slate-500"
                  }, null, 512), [
                    [_vModelCheckbox, request.value.agreeToNewsletters]
                  ]),
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    for: "agreeToNewsletters",
                    class: "block ml-2 text-sm text-gray-900"
                  }, " I want to receive e-mail updates with auditions, ticket discounts and theatre news. ", -1))
                ])
              ]),
              _createElementVNode("div", null, [
                _createVNode(SaButton, {
                  onClick: _withModifiers(createAccount, ["prevent"]),
                  loading: isSubmitting.value,
                  variant: "primary"
                }, {
                  loading: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode(" Submitting... ")
                  ])),
                  default: _withCtx(() => [
                    _cache[40] || (_cache[40] = _createTextVNode(" Create Account "))
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]))
    ])
  ], 64))
}
}

})